export default __webpack_public_path__ + "static/media/juego rio 2-29.c9bf71b8.png";